import orderBy from 'lodash/orderBy'
import uniq from 'lodash/uniq'

const isActiveCategory = (category) => category.isActive === true && category.isArchived !== true

const collectBrandIds = (categoryDocs) => uniq(categoryDocs.map((doc) => doc.brandId).filter(Boolean))

const groupCategoriesByName = (categoryDocs) => {
  const grouped = {}

  categoryDocs.forEach((category) => {
    const name = category.name?.trim()

    if (!name) {
      return
    }

    if (!grouped[name]) {
      grouped[name] = []
    }

    grouped[name].push(category)
  })

  return grouped
}

const buildSubcategoryChildren = (categoryDocs) => {
  const titleMap = new Map()

  categoryDocs.forEach((doc) => {
    ;(doc.subcategories || []).forEach((subcategory) => {
      const title = subcategory.title?.trim()

      if (!title) {
        return
      }

      if (!titleMap.has(title)) {
        titleMap.set(title, { name: title, subcategoryIds: [], brandIds: new Set() })
      }

      const node = titleMap.get(title)

      if (subcategory.id) {
        node.subcategoryIds.push(subcategory.id)
      }

      if (doc.brandId) {
        node.brandIds.add(doc.brandId)
      }
    })
  })

  return orderBy(
    [...titleMap.values()].map((node) => ({
      name: node.name,
      level: 'subcategory',
      subcategoryIds: uniq(node.subcategoryIds),
      brandIds: [...node.brandIds],
    })),
    ['name'],
    ['asc']
  )
}

export const buildCatalogCategoryTree = ({ globalCategories, categories, brandIds = [] }) => {
  const brandFilter = brandIds.length > 0 ? new Set(brandIds) : null

  const filteredCategories = categories.filter((category) => {
    if (!isActiveCategory(category) || !category.globalCategoryId) {
      return false
    }

    if (brandFilter && !brandFilter.has(category.brandId)) {
      return false
    }

    return true
  })

  return orderBy(globalCategories, ['order'], ['asc'])
    .map((globalCategory) => {
      const globalCategoryDocs = filteredCategories.filter(
        (category) => category.globalCategoryId === globalCategory.id
      )
      const groupedByName = groupCategoriesByName(globalCategoryDocs)

      const children = orderBy(
        Object.entries(groupedByName).map(([name, docs]) => ({
          name,
          level: 'category',
          categoryIds: docs.map((doc) => doc.id),
          brandIds: collectBrandIds(docs),
          children: buildSubcategoryChildren(docs),
        })),
        ['name'],
        ['asc']
      )

      return {
        id: globalCategory.id,
        name: globalCategory.name,
        url: globalCategory.url,
        order: globalCategory.order,
        level: 'global',
        brandIds: collectBrandIds(globalCategoryDocs),
        children,
      }
    })
    .filter((globalCategory) => {
      if (!brandFilter) {
        return true
      }

      return globalCategory.brandIds.length > 0
    })
}

export default buildCatalogCategoryTree
